import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.WEB_AUTH_N.SET_SUPPORT,
  payload,
})
